import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import compact from 'lodash/compact';
import request from 'helper/NetworkLayer';

const itemFetchService = (type) => {
  const query = (itemIds) => {
    if (type === 'userGroups') {
      return `
        {
          userGroups(userGroupIds: [${itemIds.toString()}]) {
            pid
            name
          }
        }
      `;
    }
    if (type === 'companies') {
      return `
        {
          companies(companyIds: [${itemIds.toString()}]) {
            pid
            name
          }
        }
      `;
    }
    return `
      {
        users(userIds: [${itemIds.toString()}]) {
          pid
          name
          uniqueId
          email
          picture
        }
      }
    `;
  };

  let fetching = false;

  let itemsFetchQueue = [];

  const removeFetchedFromQueue = (responseJSON, itemIds) => {
    if (itemIds.length > 0) {
      const itemFetchQueueClone = cloneDeep(itemsFetchQueue);

      itemIds.forEach((itemId) => {
        const index = itemFetchQueueClone.indexOf(itemId);
        if (index > -1) {
          itemFetchQueueClone.splice(index, 1);
        }
      });
      itemsFetchQueue = itemFetchQueueClone;
    }
  };

  const fetchItems = debounce(async (itemIds, callback) => {
    if (itemIds && itemIds.length > 0) {
      fetching = true;
      const response = await request('/graphql', {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          operationName: null,
          query: query('"' + compact(itemIds).join('","') + '"'),
          variables: null
        })
      });
      const responseJSON = await response.json();
      removeFetchedFromQueue(responseJSON, itemIds);
      callback && callback(responseJSON, itemIds);
      fetching = false;
      return null;
    }
    return null;
  }, 1500);

  return {
    fetchForItems: (itemId, callback) => {
      itemsFetchQueue.push(itemId);
      fetchItems(itemsFetchQueue, callback);
      return 'LOADING';
    }
  };
};

export default itemFetchService;
